<div class="container text-center" *ngIf="!success">
    <a class="btn btn-link" (click)="resendEmailConfirmationLink()">
        Click here to resend email confirmation link
    </a>
</div>